export default "__VITE_ASSET__1be92fe6__"